import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { Navbar, Header_ICor, FiltroIdeCort, IdeaCortaTod, Footer } from '../container';
import Modal_prue from '../components/modal/Modal';
import ModalVideo_prue from "../components/modal/ModalVideo.jsx";
import { useTranslation } from "react-i18next";

const IdeaCorta = () => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const idiomaliga = queryParams.get("idea");
  const [t, i18n] = useTranslation("ideaCorta");

  const [url, setUrl] = useState(
    `https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/ideas/searchbytitle?words=envidia&lang=es`
  );
  const [contenido, setContenido] = useState('');
  const [tipo, setTipo] = useState('');
  const [preview, setPreview] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [id_liga, setId_liga] = useState("");
  const [variable1, setVariable1] = useState("");
  const [variable2, setVariable2] = useState("");

  const [isOpenModalVideo, setIsOpenModalVideo] = useState(false);
  const [urlVideo, setUrlVideo] = useState("");

  const closeModal = () => {
    setVariable1("");
    setVariable2("");
    setIsModalOpen(false);
  };

  const openModal = (value1, value2, value3, value4) => {
    setVariable1(value1);
    setVariable2(value2);
    setId_liga(value4);
    setIsModalOpen(true);
  };

  const openModalVideo = (contenido) => {
    setUrlVideo(contenido);
    setIsOpenModalVideo(true);
  };

  const closeModalVideo = () => {
    setUrlVideo("");
    setIsOpenModalVideo(false);
  };

  useEffect(() => {
    if (idiomaliga) {
      axios.get(`https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/ideas/searchbyId?id=${idiomaliga}&lang=es`)
        .then(response => {
          const data = response.data[0]; // Asumiendo que siempre hay solo un elemento en el array
          console.log(data);

          if (data.tipo === "texto-imagen") {
            openModal(data.contenido, "", data.preview, idiomaliga);
          } else if (data.tipo === "texto-video") {
            openModal(data.contenido, "", data.preview, idiomaliga);
          } else if (data.tipo === "carrete") {
            openModal(data.contenido, "carrete", data.preview, idiomaliga);
          } else if (data.tipo === "youtube") {
            openModalVideo(data.contenido);
          } else if (data.tipo === "video") {
            openModal("https://www.ricardosalinas.com" + data.contenido, "video", data.preview, idiomaliga);
          } else {
            console.log("Tipo incorrecto");
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }
  // Dependencia vacía para que se ejecute solo una vez al montar el componente
  }, []);

  return (
    <div className="App_DB">
      <Navbar />
      <Header_ICor />
      <FiltroIdeCort />
      <Modal_prue
        isOpen={isModalOpen}
        closeModal={closeModal}
        variable1={variable1}
        id_idea={id_liga}
        variable2={variable2}
      />

      <ModalVideo_prue
        isOpen={isOpenModalVideo}
        closeModal={closeModalVideo}
        urlVideo={urlVideo}
      />
      <Footer />

    </div>
  );
};

export default IdeaCorta;